import { useState } from 'react'

import { handleErrors } from '../error-handling'

const useFormSubmit = () => {
  const [loadingState, setLoadingState] = useState(false)
  const [submitedState, setSubmitedState] = useState(false)
  const [errorState, setErrorState] = useState(false)

  const handleSubmit = async (url, data) => {
    try {
      setLoadingState(true)

      const userCountryCode = localStorage.getItem('country_code')
      const bodyData = `${data}&country=${userCountryCode}`

      const requestOptions = {
        method: 'POST',
        mode: 'cors',
        headers: {
          Accept:
            'application/json, application/xml, text/plain, text/html, *.*',
          'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8',
        },
        body: bodyData,
      }

      const response = await fetch(url, requestOptions)

      await handleErrors(response)

      setSubmitedState(true)
      setLoadingState(false)
      setErrorState(false)
    } catch (error) {
      console.log(error)

      setSubmitedState(false)
      setLoadingState(false)
      setErrorState(true)
    }
  }

  return {
    loadingState,
    submitedState,
    errorState,
    handleSubmit,
  }
}

export default useFormSubmit
